import React from 'react';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);

const prompt = ({ title }) => {
  return MySwal.fire({
    title,
    text: "No podrás revertir esto",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sí, eliminar!'
  });
}

const DeleteFileButton = ({
  title = "¿Seguro desea eliminar el archivo?",
  onDeleteConfirm,
  disabled,
  variant = "destructive",
  size = "sm",
  className = "text-xs rounded-lg ml-2",
  iconSize = 16,
  iconClassName = ""
}) => {
  const handleDelete = (e) => {
    e.preventDefault();
    prompt({ title }).then(result => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        onDeleteConfirm && onDeleteConfirm();
      }
    });

  }
  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleDelete}
      disabled={disabled}
      className={className}
    >
      <Trash2 size={iconSize} className={iconClassName} />
    </Button>
  );
}

export default DeleteFileButton;